import { render, staticRenderFns } from "./IssueInformationCard.vue?vue&type=template&id=2d60a540&scoped=true"
import script from "./IssueInformationCard.vue?vue&type=script&lang=ts"
export * from "./IssueInformationCard.vue?vue&type=script&lang=ts"
import style0 from "./IssueInformationCard.vue?vue&type=style&index=0&id=2d60a540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60a540",
  null
  
)

export default component.exports